import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AiAppIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.5 2.5H10.5C12.1569 2.5 13.5 3.84315 13.5 5.5V10.5C13.5 12.1569 12.1569 13.5 10.5 13.5H5.5C3.84315 13.5 2.5 12.1569 2.5 10.5V5.5C2.5 3.84315 3.84315 2.5 5.5 2.5ZM1 5.5C1 3.01472 3.01472 1 5.5 1H10.5C12.9853 1 15 3.01472 15 5.5V10.5C15 12.9853 12.9853 15 10.5 15H5.5C3.01472 15 1 12.9853 1 10.5V5.5ZM7.04311 4.78446L6.77126 6.14369C6.73346 6.3327 6.71456 6.4272 6.66796 6.50318C6.62678 6.57032 6.57032 6.62678 6.50318 6.66796C6.4272 6.71456 6.3327 6.73346 6.14369 6.77126L4.78446 7.04311C4.32833 7.13433 4 7.53483 4 8C4 8.46517 4.32833 8.86567 4.78446 8.95689L6.14369 9.22874L6.14372 9.22874C6.3327 9.26654 6.42721 9.28544 6.50318 9.33204C6.57032 9.37322 6.62678 9.42968 6.66796 9.49682C6.71456 9.5728 6.73346 9.6673 6.77126 9.85631L7.04311 11.2155C7.13433 11.6717 7.53483 12 8 12C8.46517 12 8.86567 11.6717 8.95689 11.2155L9.22874 9.85631C9.26654 9.6673 9.28544 9.5728 9.33204 9.49682C9.37322 9.42968 9.42968 9.37322 9.49682 9.33204C9.57279 9.28544 9.6673 9.26654 9.85629 9.22874L9.85631 9.22874L11.2155 8.95689C11.6717 8.86567 12 8.46517 12 8C12 7.53483 11.6717 7.13433 11.2155 7.04311L9.85631 6.77126C9.6673 6.73346 9.5728 6.71456 9.49682 6.66796C9.42968 6.62678 9.37322 6.57032 9.33204 6.50318C9.28544 6.42721 9.26654 6.3327 9.22874 6.1437L9.22874 6.14369L8.95689 4.78446C8.86567 4.32833 8.46517 4 8 4C7.53483 4 7.13433 4.32833 7.04311 4.78446Z"
		></path>
	</svg>
))
